import MapSpinner from '../junk/views/mapspinner';
import MapManager from '../managers/leafletMapManager';
import * as Guards from '../libs/guards'
// const $ = require('jquery');
/**
 * MapOptions is a type returned by the getMapOptions() function. It find some of those options in
 * a custom property on the global windows object and fills in the other as defaults.
 */
type MapOptions = {
    map_type		        : "site-map" | "" | "",
    url				        : string,  // site relative url required to get the acual marker and track data for the map
    center_lat              : number,
    center_lng              : number,
    fit_bounds 		        : boolean, // default true,
    zoom                    : number,
    w_map_spinner_enabled   : boolean,
    w_map_content_id        : string,  //default '#w_map_content',
    w_map_canvas_id	        : string,  // default '#w_map_canvas',
    w_map_spinner_class	    : string,  // default 'map-loading-spinner',
    w_map_spinner_image_url	: string,  // default '.....skins / rtw/images/spinner.gif',
}
/**
 * The data for the map consists of both markers representing campng places or lodgings and tracks
 * which are arrays of points to be drawn as polylines. These are pgx style tracks.
 * 
 * A MapDetail instance is retrieved ffrom the server via a fetch() call using the url value in the 
 * active MapOptions object.
 * 
 * An instance of MapDetails will always have an array of markers:Markers and tracks may be 
 * -    empty .. the most common
 * -    have one entry .. for a single gpx track .. the next most common situation
 * -    multiple entries representing multiple indepent trips or routes
 */
type MapDetails = {
      markers: Array<Marker>
      tracks: Array<Track> | null
 }
type Marker = {
     country: string,
     date: string,
     excerpt: string,
     icon_url: string,   // site relative url to the .png image for the marker icon
     lat: number,
     lng: number,
     link: string,       // site relative link to the corresponding post/journal entry
     place: string,
     title: string,
     trip: string,
     vehicle: string,
}

type Track = {
     bounds: Bounds,
     color: string,      //such as #ff0000
     opacity: number,    // positive
     weight: number,     // positive
     popitns: Array<Point>
}

type Point = {
     lat: number, // floating point between -180.0 and +180.0
     lng: number  // same
}

type Bounds = {
      maxlat: number, minlat: number, maxlng: number, minlng: number
}

interface WindowEnhanced {
    WhiteacornMap: { options: MapOptions}
}
function getGlobalMapOptions(window: any): MapOptions| null {
    if ( window.hasOwnProperty('WhiteacornMap')) {
        const we = window as WindowEnhanced
        if(we.WhiteacornMap.options.hasOwnProperty('map_type')) {
            const weo = we.WhiteacornMap.options as MapOptions
            return weo
        }
    }
    return null
}

/**
 * This module loads a map with markers and possibly plylines if appropriate.
 * 
 * If Appropriate How ?
 * ====================
 * Look in the get_map_options() function. If this function returns null then the page
 * does not require a map
 * 
 */

export function map_init() {
    map_init_1()
}
/**
 * map_init_1 gets the data for and then draws a single map.
 * It uses a "functional" style - a single outter function with inner functions.
 * 
 * Compare to map_init_2 below
 * 
 * @returns 
 */
function map_init_1() {
    
    const options = getMapOptions()
    if(options === null)
        //this is not a map page
        return
    let map_content_div = document.getElementById(options.w_map_content_id.slice(1))
    let map_canvas = document.getElementById(options.w_map_canvas_id.slice(1))
    if(map_canvas) {
        // good nothing to do
    } else if (map_content_div ) {
        map_content_div.innerHTML = `
            <div id="w_map_canvas" class="w_map_canvas map_canvas clearfix">
            </div>
        `
        map_canvas = document.getElementById(options.w_map_canvas_id.slice(1))
    } else {
        throw new Error(`map_init Error page has map options BUT there is no map canvas, Doing nothing`)
        return
    }
    const map_canvas_el = Guards.isHTMLDiv(map_canvas)
    const spinner = new Spinner(map_canvas_el, options)

    spinner.show()
    
    fetch_data(options.url, function(map_details: MapDetails) {
        spinner.hide()
        drawMap(map_canvas_el, options.center_lat, options.center_lng, options.zoom, map_details)
    })
}
function fetch_data(url: string, callback:(md: MapDetails)=>void) {
    const response = fetch(url,
        {
            headers:{
                'Content-type':'application/json'
            }
    }).then(response => {
        if(!response.ok) {
            throw new Error("network error")
        }
        return response.json()
    }).then(data => {
        const map_details = parseData(data)
            if(map_details == null) {
                alertResponseText(data)
                throw new Error("parsing of map data failed")
            } else {
                callback(map_details)
            }
    })
}
function parseData(data: any): MapDetails {
    if(!data.hasOwnProperty('return_code') && !data.hasOwnProperty('markers')) {
        throw Error("mapper - json data is missing one of return_code markers")
    }
    let md = {
        return_code: data.return_code,
        markers: data.markers,
        tracks: (data.hasOwnProperty('tracks') ? data.tracks: (data.hasOwnProperty('track')) ? [data.track]: null)
    }
    return md
}
function drawMap(canvas_element: HTMLDivElement, center_lat: number, center_lng: number, zoom: number, map_details: MapDetails) {
    // note the MapManager must be created after the spinner is done. Have not worked out why.
    const mm = new MapManager(canvas_element, {
        center_lat: center_lat, 
        center_lng: center_lng, 
        zoom: zoom
    })
    mm.addMarkers(map_details.markers)
    if(map_details.tracks !== null) {
        mm.addTracks(map_details.tracks)
    }
    mm.setExplicitCenterAndZoom([center_lat, center_lng], zoom);
    mm.map.invalidateSize();
}

/**
 * This function gets options that control how maps are made.
 * Any page that wants to have a map must have a piece of js code that add a property 
 * WhiteacornMap to the browser window object.
 * 
 * The WhiteacirnMap property must be of type MapOption as defined below
 * 
 * @returns Make a map options object. It has the form
 * type MapOptions = {
     *      map_type		: "site-map" | "" | "",
     *      url				: string,  // site relative url required to get the acual marker and track data for the map
     *
     *  fit_bounds 		     : bool,                             // default true,
     *  w_map_content_id     : string,                           //default '#w_map_content',
     *  w_map_canvas_id	     : string,                           // default '#w_map_canvas',
     *  w_map_spinner_class	 : string,                           // default 'map-loading-spinner',
    *   w_map_spinner_image_url	     : string,
     * }
 * }
 */
function getMapOptions(): MapOptions|null {
    /**
     * Map options are attached to the global windows object by the php code that builds the
     * host provided html page.
     * 
     * If the options are not found that idicates that this page is NOT a map page so there
     * is nothing to do. Similarly  if the global variable is dfined but its type is not an 'object'.
     */
    const window_map_options = getGlobalMapOptions(window)
    if ( ! window_map_options) {
		console.log(['mapBehavior not required ']);
		return null;
	}
    /**
     * Generally the options provided in the map page will not specify the values:
     *  w_map_content_id 	    : '#w_map_content',
     *  w_map_canvas_id	        : '#w_map_canvas',
     *  w_map_spinner_class	    : 'map-loading-spinner',
     *  w_map_spinner_image_url	: ' ......./ rtw / images/spinner.gif',
     *
     * These are added to the options object that will be rreturned.
     */
    const default_options = {
        w_map_spinner_enabled: true,
        w_map_content_id 	: '#w_map_content',
        w_map_canvas_id	: '#w_map_canvas',
        w_map_spinner_class	: 'map-loading-spinner',
        w_map_spinner_image_url	: '/skins/rtw/images/spinner.gif',
       }
	const opts = window_map_options;

	const options = Object.assign(default_options, opts);
    return options as MapOptions       
}

class Spinner{
    el: HTMLDivElement
    w_map_spinner_image_url: string
    w_map_spinner_class: string
    w_map_spinner_class_selector: string
    w_map_spinner_enabled: boolean
    sel_height: any
    sel_width: any
    constructor(canvas_element: HTMLDivElement, options: MapOptions) {
        console.log(['Spinner', canvas_element])
        this.el = canvas_element
        this.w_map_spinner_enabled = options.w_map_spinner_enabled
        this.w_map_spinner_image_url = options.w_map_spinner_image_url
        this.w_map_spinner_class = options.w_map_spinner_class
        this.w_map_spinner_class_selector = `.${this.w_map_spinner_class}`
    }
	show() {
        if(!this.w_map_spinner_enabled) {
            return
        }
        const spp = this.el.querySelector(`${this.w_map_spinner_class_selector}`)
		if ( !spp ) {
			const html = `
            <div class=${this.w_map_spinner_class} style='height:100%;width:100%;display:flex;justify-content:center;align-content:center'>
                <img src=${this.w_map_spinner_image_url} style="margin:auto;" ></img>
            </div>`
            this.el.innerHTML = html
            // const spinner_el = Guards.isHTMLDiv(this.el.querySelector('.map-loading-spinner'))
            // const h = parseInt(spinner_el.style.height)
            // const w = parseInt(spinner_el.style.width)
			// const h2 = (this.sel_height - h) / 2.0;
			// const w2 = (this.sel_width - w) / 2.0;
		}
	}

	hide() {
        if(!this.w_map_spinner_enabled) {
            return
        }
        const spp = this.el.querySelector(`${this.w_map_spinner_class_selector}`)
		if ( spp ) {
            spp.remove()
		}
	}
}
function alertResponseText(xhr_response_text: string) {
	alert(xhr_response_text); // eslint-disable-line no-alert
}
